import { useGetIdentity } from "@refinedev/core";
import { UserType } from "constants/common";

export const useUserType = () => {
  const { data: user } = useGetIdentity<any>();

  return {
    isInternalUser: user?.userType === UserType.INTERNAL,
    isDiscountedUser: user?.userType === UserType.DISCOUNTED,
    isFreeUser: user?.userType === UserType.FREE,
    isPaidUser: user?.userType === UserType.PAID,
    isAdminUser: user?.role?.type?.toLowerCase() === "admin"
  };
};
